"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _formContract = require("@/types/formContract");
var _formStop = require("@/api/form-stop.api");
var StopContractTable = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(StopContractTable, _Vue);
  var _super = (0, _createSuper2.default)(StopContractTable);
  function StopContractTable() {
    var _this;
    (0, _classCallCheck2.default)(this, StopContractTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ContractTagOptions", _formContract.ContractTagOptions);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ContractStatusTrans", _formContract.ContractStatusTrans);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "FormStopContractStatus", _formContract.FormStopContractStatus);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleComplete", function (numberId) {
      _this.$confirm("Xác nhận đã hoàn thành yêu cầu của hợp đồng này. Tiếp tục?", "Warning", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _formStop.formStopApi.complete(numberId);
              case 2:
                _this.$message({
                  type: "success",
                  message: "Đã Hoàn thành"
                });
                _this.$emit("fetchData");
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "generateMonth", function (monthValue) {
      if (monthValue < 12) {
        return monthValue + " tháng";
      } else {
        var year = Math.floor(monthValue / 12);
        var months = monthValue % 12;
        return "".concat(year, " n\u0103m ").concat(months > 0 ? months + " tháng" : "");
      }
    });
    return _this;
  }
  return (0, _createClass2.default)(StopContractTable);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], StopContractTable.prototype, "data", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], StopContractTable.prototype, "loading", void 0);
StopContractTable = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], StopContractTable);
var _default = StopContractTable;
exports.default = _default;